// E.164 normalization for phone input — a faithful copy of shared/broadcast/normalize.normalizeE164,
// re-implemented locally so the web bundle never imports server runtime from @crosscastr/shared
// (the app imports ONLY types from shared). Returns E.164 WITH a leading '+', which is what the
// platform API's phone schema requires (/^\+[1-9]\d{7,14}$/). The backend remains the validator.
//   0545660226 → +972545660226   972545660226 → +972545660226   545660226 → +972545660226

export function toE164(raw: string, defaultCc = '972'): string {
  let d = raw.replace(/[^0-9]/g, '');
  if (!d) return '';
  if (d.startsWith('00')) d = d.slice(2); // 00-prefixed international dialing
  if (d.startsWith(defaultCc)) return `+${d}`; // already carries the default country code
  if (d.startsWith('0')) return `+${defaultCc}${d.slice(1)}`; // local 0-prefix → country code
  if (d.length === 9 && d.startsWith('5')) return `+${defaultCc}${d}`; // bare IL mobile
  return `+${d}`; // assume it already includes a (non-default) country code
}
